import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { Upload } from 'lucide-react';

const ALLOWED_EXTENSIONS = new Set([
  '.pdf', '.docx', '.pptx', '.xlsx', '.xls',
  '.jpg', '.jpeg', '.png', '.tiff', '.tif', '.bmp', '.webp',
]);

const FORMATS_LABEL = 'PDF, DOCX, PPTX, XLSX, JPG, PNG, TIFF, BMP, WebP';
const MAX_SIZE = 50 * 1024 * 1024;

function getExtension(name) {
  const dot = name.lastIndexOf('.');
  return dot >= 0 ? name.slice(dot).toLowerCase() : '';
}

export default function UploadZone({ onUpload, onReject }) {
  const onDrop = useCallback(
    (acceptedFiles) => {
      if (acceptedFiles.length === 0) return;

      const file = acceptedFiles[0];

      if (file.size > MAX_SIZE) {
        if (onReject) {
          onReject(`Le fichier "${file.name}" depasse la taille maximale de 50 MB.`);
        }
        return;
      }

      const ext = getExtension(file.name);
      if (!ALLOWED_EXTENSIONS.has(ext)) {
        if (onReject) {
          onReject(
            `Le format du fichier "${file.name}" n'est pas supporte. Formats acceptes : ${FORMATS_LABEL}.`,
          );
        }
        return;
      }

      onUpload(file);
    },
    [onUpload, onReject],
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    maxFiles: 1,
    // No accept filter — we validate manually so the file dialog shows all files
    // and unsupported files trigger an error notification instead of being silently ignored
  });

  return (
    <div className="dropzone-wrapper">
      <div
        {...getRootProps()}
        className={`dropzone ${isDragActive ? 'active' : ''}`}
      >
        <input {...getInputProps()} />
        <div className="dropzone-icon">
          <Upload size={32} />
        </div>
        <p className="dropzone-text">
          {isDragActive ? (
            'Deposez le fichier ici...'
          ) : (
            <>
              Glissez un fichier ou <strong>cliquez pour parcourir</strong>
            </>
          )}
        </p>
        <p className="dropzone-hint">
          {FORMATS_LABEL} — Max 50 MB
        </p>
      </div>
    </div>
  );
}
